export const ICON_CONTAINER =
    " flex flex-col h-[176px] w-[276px]  rounded-tl-full items-center rounded-tr-full justify-center mx-auto";
export const DETAILS_CLASS =
    "text-center text-Text_White text-base font-medium w-[80%] my-auto";
